import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "toast-body" }

import { computed } from 'vue';
import { useMessageStore } from '@/store/message.store';


export default /*@__PURE__*/_defineComponent({
  __name: 'Message',
  setup(__props) {

const messageStore = useMessageStore();
const message = computed(() => messageStore.getMessage);
const status = computed(() => `bg-${messageStore.getStatus}`);
const clearMessage = () => {
  messageStore.$reset();
};

return (_ctx: any,_cache: any) => {
  return (message.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["toast align-items-center show", [status.value]]),
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(`messages.${message.value}`)), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close me-2 m-auto",
            "aria-label": "Close",
            onClick: clearMessage
          })
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})